var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L17.1209 17.1209",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07097 2.7309C1.8466 3.07726 1.71582 3.49075 1.71582 3.93428V14.193C1.71582 15.4166 2.70775 16.4085 3.93135 16.4085H14.1901C14.6338 16.4085 15.047 16.2781 15.3936 16.0535L14.2464 14.9064C14.2278 14.9078 14.209 14.9085 14.1901 14.9085H3.93135C3.53617 14.9085 3.21582 14.5882 3.21582 14.193V3.93428C3.21582 3.91531 3.21655 3.89651 3.21799 3.87792L2.07097 2.7309ZM14.9056 11.3229V3.93428C14.9056 3.5391 14.5853 3.21875 14.1901 3.21875H6.80146L5.30146 1.71875H14.1901C15.4137 1.71875 16.4056 2.71068 16.4056 3.93428V12.8229L14.9056 11.3229Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareOff);
export default __webpack_public_path__ + "static/media/square-off.30dd7e9c1803f86cdf9260ecb615ea79.svg";
export { ForwardRef as ReactComponent };